import { PPLX_LOSS_AVERSION_MODAL_STATUS } from '#pplx/frontend/apps/ask/browser-state/cookieConstants.js';
import { setLossAversionModalStatusCookie } from '#pplx/frontend/apps/ask/browser-state/cookieManager.js';
import { getCookie, removeCookie } from '#pplx/frontend/cookies/provider.js';
import { useCallback, useMemo } from 'react';
export const useLossAversionStorage = () => {
    // "allowed" = loss aversion modal can show on navigation event from thread
    // "cooldown" = loss aversion modal is prevented. right now "cooldown" is never cleared, so each user should only see this once per browser
    const setLossAversionStatus = useCallback((status) => {
        setLossAversionModalStatusCookie(status);
    }, []);
    const lossAversionStatus = getCookie(PPLX_LOSS_AVERSION_MODAL_STATUS);
    const unsetLossAversion = useCallback(() => removeCookie(PPLX_LOSS_AVERSION_MODAL_STATUS), []);
    return useMemo(() => ({ lossAversionStatus, setLossAversionStatus, unsetLossAversion }), [lossAversionStatus, setLossAversionStatus, unsetLossAversion]);
};
//# sourceMappingURL=useLossAversionStorage.js.map